export default class VueRegister_serviceConfig {
    static getBaseURL() {
        return "https://pchelp.1oo0.ru/";
    }
}
